<template>
	<div class="ui-tabs">
		<span :class="['ui-tabs-tab', {'ui-tabs-tab--active': tab.key === localValue}]" v-for="tab in tabs" :key="tab.key" @click="setActiveTab(tab.key)">
			<i v-if="tab.icon" :class="['fas', tab.icon]" />
			{{ tab.label }}
		</span>
	</div>
</template>

<script>
export default {
	props: {
		value: {
			type: String
		},

		tabs: {
			type: Array,
			default: () => ([])
		}
	},

	data: () => ({
		localValue: null
	}),

	watch: {
		value(to) {
			this.localValue = to;
		},

		localValue(to) {
			this.$emit('input', to);
		}
	},

	created() {
		this.localValue = this.value;
	},

	methods: {
		setActiveTab(key) {
			this.localValue = key;
		}
	}
};
</script>

<style lang="scss">
.ui-tabs {
	display: inline-flex;
	align-items: center;
	position: relative;
	top: 1px;
	z-index: 1;
}
.ui-tabs-tab {
	cursor: pointer;
	font-size: 12px;
	letter-spacing: 0.05rem;
	padding: 5px 10px;
	background-color: darken(#4d535d, 10%);
	border-right: 1px solid darken(#363a41, 1%);
	box-shadow: rgba(0, 0, 0, 0.25) 0px 0.0625em 0.0625em, rgba(0, 0, 0, 0.25) 0px 0.125em 0.5em, rgba(255, 255, 255, 0.1) 0px 0px 0px 1px inset;

	transition: background-color 0.3s ease;

	&:hover {
		transition: background-color 0.3s ease;
		background-color: lighten(#4d535d, 10%);
	}

	i {
		margin-right: 5px;
		color: white;
	}

	&:first-child {
		border-top-left-radius: 4px;
	}

	&:last-child {
		border-top-right-radius: 4px;
		border-right: 0;
	}


}

.ui-tabs-tab--active {
	background-color: #4d535d;
	color: #e66f1f;
	i {
		color: #e66f1f;
	}
}
</style>
